export default __webpack_public_path__ + "static/media/heading1.18c69686.svg";